import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  ComponentFactoryResolver,
  OnDestroy,
  AfterViewInit,
} from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import {
  QuestionListDirective,
  QuestionItem,
  SurveyStateService,
  ProgressSpinnerService,
  getQuestions,
  QuestionComponent,
} from '../../public-api';
import { surveysConfig } from '../../../../client/src/surveys-config';

@Component({
  selector: 'app-survey-content',
  templateUrl: './survey-content.component.html',
  styleUrls: ['./survey-content.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SurveyContentComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(QuestionListDirective, { static: false }) questionList: QuestionListDirective;
  currentPageQuestions: QuestionItem[];
  private answerSavedSubscription: Subscription;
  private questionGroupLoadedSubscription: Subscription;
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private surveyStateService: SurveyStateService,
    private progressSpinnerService: ProgressSpinnerService,
    private messageService: MessageService,
  ) {}

  ngOnInit() {
    this.answerSavedSubscription = this.surveyStateService.answerSaved.subscribe((data) => {
      if (!data.successStatus) {
        this.showError('Save failed');
      }
    });
  }

  ngAfterViewInit() {
    this.questionGroupLoadedSubscription = this.surveyStateService.questionGroupLoaded.subscribe(
      (data) => {
        if (data === true) {
          this.currentPageQuestions = this.getCurrentPageQuestions();
          this.loadComponent();
        }
      },
      (_) => this.showError('Question group load failed.'),
    );
  }

  getCurrentPageQuestions() {
    const questions = this.surveyStateService.GetQuestionsForTheCurrentQuestionGroupAndForSurveyType();
    var questionAnswerInstanceListInGroup = this.surveyStateService.GetCurrentQuestionAnswerInstanceListInGroup();

    return getQuestions(questions, questionAnswerInstanceListInGroup);
  }

  loadComponent() {
    // setTimeout(() => {
    try {
      const viewContainerRef = this.questionList.viewContainerRef;
      viewContainerRef.clear();

      this.currentPageQuestions.forEach((question) => {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(question.component);
        const componentRef = viewContainerRef.createComponent(componentFactory);
        (componentRef.instance as QuestionComponent).questionData = question.questionData;
        (componentRef.instance as QuestionComponent).questionAnswerInstanceList = question.questionAnswerInstanceList;
        (componentRef.instance as QuestionComponent).messageService = this.messageService;
        (componentRef.instance as QuestionComponent).surveyStateService = this.surveyStateService;
        (componentRef.instance as QuestionComponent).readonly = this.surveyStateService.isOldSurvey(
          surveysConfig.previousYearSurveyId,
        );
      });
    } catch (error) {
      // Handle the error
      console.error('An error occurred:', error);
    }
    // }, 5000);
  }

  showError(message) {
    this.messageService.clear();
    this.messageService.add({ severity: 'error', summary: 'Error', detail: message, sticky: false });
    this.progressSpinnerService.hide();
  }

  showInfo(message) {
    this.messageService.clear();
    this.messageService.add({ severity: 'info', summary: 'Info', detail: message, sticky: false });
    this.progressSpinnerService.hide();
  }

  getQuestionGroupText() {
    const qg = this.surveyStateService.GetActiveSurveySection();
    return qg ? qg.text : '';
  }

  ngOnDestroy(): void {
    this.answerSavedSubscription.unsubscribe();
    this.questionGroupLoadedSubscription.unsubscribe();
  }
}
